import React from 'react';

const NotFound: React.FC = () => (
  <div className="min-h-full flex items-center justify-center py-12 md:py-20">
    <div className="text-center">
      <div className="text-zinc-500 text-[10px] font-bold tracking-widest uppercase mb-3">404</div>
      <div className="text-white text-2xl md:text-4xl font-black tracking-tighter">Page not found</div>
      <div className="text-zinc-500 mt-3 text-sm md:text-base">The page you’re looking for doesn’t exist.</div>
    </div>
  </div>
);

export default NotFound;
